var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'component',
    'component__badge_role',
    _vm.type ? `component__badge_role--type-${_vm.type}` : '',
    _vm.size ? `component__badge_role--size-${_vm.size}` : ''
]},[_c('span',[_vm._v(_vm._s(_vm.roleOutput))])])
}
var staticRenderFns = []

export { render, staticRenderFns }